import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetMemberships  
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Create an organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestCreateNewOrganization = packet => {
  return {
    type: 'REQUEST_CREATE_NEW_ORGANIZATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateNewOrganizationSuccess = data => ({
  type: 'RECEIVE_CREATE_NEW_ORGANIZATION_SUCCESS',
  data
})

export const receiveCreateNewOrganizationFail = data => ({
  type: 'RECEIVE_CREATE_NEW_ORGANIZATION_FAIL',
  data
})

export const tryToCreateNewOrganization = packet => (dispatch, getState) => {

  dispatch(requestCreateNewOrganization(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/organizations', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCreateNewOrganizationSuccess(json));
      dispatch(tryToGetMemberships());
      dispatch(push('/workbench/' + json.id));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCreateNewOrganizationFail({errors:e, lastSubmit: packet}));
    })
}
